import { GET_CAMPAGNE_ATTIVE_SCREENING, GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS, RESET_PERSISTENT_STORE_STATE, SET_CAMPAGNA, } from "./actionsType";

export const setCampagnaAction = (payload) => ({
    type: SET_CAMPAGNA,
    payload
})
export const resetPersistentStoreStateAction = () => ({
    type: RESET_PERSISTENT_STORE_STATE
})

export const getCampagneAttiveScreeningAction = () => ({
    type: GET_CAMPAGNE_ATTIVE_SCREENING
})
export const getCampagneAttiveScreeningActionSuccess = (payload) => ({
    type: GET_CAMPAGNE_ATTIVE_SCREENING_SUCCESS,
    payload
})